import { render } from "./VueBookingQuickfinder.vue?vue&type=template&id=2c83b9b8"
import script from "./VueBookingQuickfinder.vue?vue&type=script&lang=js"
export * from "./VueBookingQuickfinder.vue?vue&type=script&lang=js"

import exportComponent from "/builds/Spartans/alpbachtal-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__